function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#2196F3",
  d: "M.487.03h23.467c.269 0 .487.218.487.487v10.735a.487.487 0 01-.487.487H9.936l-2.655 2.607-2.558-2.607H.487A.486.486 0 010 11.252V.517C0 .337.162.176.487.03z"
});

var _ref2 = /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "NotoSans-Bold, Noto Sans",
  fontSize: 8,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 3,
  y: 9
}, "NEW"));

function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15
  }, props), _ref, _ref2);
}

export default SvgNew;